import React, { useRef, Suspense } from 'react';
import {
  Platform,
  StyleSheet
} from 'react-native';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import { SafeAreaProvider } from 'react-native-safe-area-context';

import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { init } from '@amplitude/analytics-react-native';

import App from '../containers/AppContainer';
import { BackgroundPrimary } from '../components/App';

import { initialize } from '../../actions/';
import rootReducer from '../../reducers/';
import rootSaga from '../../common/sagas/';
import AppVariantContext from '../../utils/AppVariantContext';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);
store.dispatch(initialize());

init('2e6e17401f4358e029ef91258071003');

const app_variant = process.env.REACT_APP_APP_VARIANT ? process.env.REACT_APP_APP_VARIANT : "savori";

const AppRoot = () => {
  const { t } = useTranslation(['common']);

  return (
    <HelmetProvider>
      <AppVariantContext.Provider value={app_variant}>
        <Provider store={store}>
          <Suspense fallback={<BackgroundPrimary/>}>
            <SafeAreaProvider style={styles.container}>
              {
                Platform.select({
                  web: () => (
                    <Helmet>
                      <title>{ t('common:app.metaTags.default.title') }</title>
                      <meta property="og:title" content={ t('common:app.metaTags.default.title') } />
                      <meta property="og:site_name" content="savori.app" />
                      <meta property="description" content={ t('common:app.metaTags.default.description') } />
                      <meta property="og:description" content={ t('common:app.metaTags.default.description') } />
                      <meta property="keywords" content={ t('common:app.metaTags.default.keywords') } />
                      <meta property="og:type" content="website" />
                      <meta property="og:locale" content={i18n.language} />
                    </Helmet>
                  ),
                  default: null
                })
              }
              <App />
            </SafeAreaProvider>
          </Suspense>
        </Provider>
      </AppVariantContext.Provider>
    </HelmetProvider>
  )
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%'
  }
});

export default AppRoot;
